import React from 'react';

import SidebarMenu, { type SidebarMenuItem } from './sidebar-menu';

const items: SidebarMenuItem[] = [
  {
    key: 'post-suggestions',
    to: '/marketing/suggestions',
    label: 'Post Suggestions',
  },
  {
    key: 'social-networks-settings',
    to: '/marketing/settings',
    label: 'Social Networks',
  },
];

function SidebarMarketing(): React.ReactElement {
  return <SidebarMenu items={items} />;
}

export default SidebarMarketing;
